import React from "react";
import "./Footer.css";
import insta from "../../assets/instagram.png";
import github from "../../assets/github.png";
import linkedIn from "../../assets/linkedin.png";
import logo from "../../assets/logo.png";
const Footer = () => {
  return (
    <div className="footer-container">
      <div className="blur footer-blur-1"></div>
      <div className="blur footer-blur-2"></div>
      <hr />
      <div className="footer">
        <div className="social-imgs">
          <img src={insta} alt="" />
          <img src={github} alt="" />
          <img src={linkedIn} alt="" />
        </div>
        <div className="f-logo">
          <img src={logo} alt="" />
        </div>
      </div>
    </div>
  );
};

export default Footer;
